'use client';

import * as React from 'react';
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group';

import { cn } from '@design-system/lib/utils';

function ChoiceRadio({
  className,
  ...props
}: React.ComponentProps<typeof RadioGroupPrimitive.Root>) {
  return (
    <RadioGroupPrimitive.Root
      data-slot="choice-radio"
      className={cn('flex flex-col gap-3', className)}
      {...props}
    />
  );
}

interface ChoiceRadioItemProps
  extends React.ComponentProps<typeof RadioGroupPrimitive.Item> {
  title: string;
  description?: string;
}

function ChoiceRadioItem({
  className,
  title,
  description,
  ...props
}: ChoiceRadioItemProps) {
  return (
    <RadioGroupPrimitive.Item
      data-slot="choice-radio-item"
      className={cn(
        'group flex w-full cursor-pointer items-start justify-between rounded-lg border border-input bg-background p-3.5 text-left transition-colors',
        'hover:border-primary/30',
        'focus-visible:outline-none',
        'data-[state=checked]:border-primary',
        'disabled:cursor-not-allowed disabled:opacity-50',
        className,
      )}
      {...props}
    >
      <div className="flex flex-col gap-1">
        <span className="text-sm font-medium text-gray-950 leading-none">{title}</span>
        {description && (
          <span className="text-sm text-foreground">{description}</span>
        )}
      </div>
      <div
        className={cn(
          'flex size-4 shrink-0 items-center justify-center rounded-full border border-input transition-colors',
          'group-data-[state=checked]:border-primary group-data-[state=checked]:bg-primary',
        )}
      >
        <RadioGroupPrimitive.Indicator
          data-slot="choice-radio-indicator"
          className="flex items-center justify-center"
        >
          <div className="size-2 rounded-full bg-primary-foreground" />
        </RadioGroupPrimitive.Indicator>
      </div>
    </RadioGroupPrimitive.Item>
  );
}

export { ChoiceRadio, ChoiceRadioItem };
